import { Box } from "@mui/material";
import "./activityArea.scss";

export const ActivityArea = (props: any) => {
  return (
    <Box
      className="main-wrapper"
      component="main"
      width={"100%"}
      // sx={{ flexGrow: 1, p: 3, flexWrap: "wrap" }}
      marginTop="4.6875rem"
    >
      {props.children}
    </Box>
  );
};

export default ActivityArea;
